import configs from '../../configs'
import schema from '../json/schema'
import manager from '../json/manager'
export default {
  data () {
    return {
      adminTitle: configs.title,
      schema: schema,
      manager1: manager
    }
  },
  computed: {
    manager () {
      let manager = this.manager1.find(item => {
        return item.className === this.$route.params.className
      })
      if (!manager) return
      manager = JSON.parse(JSON.stringify(manager))
      let hasAllField = manager.fields.find(item => {
        return item.name === 'createdAt'
      })
      if (!hasAllField) {
        manager.fields.push({
          name: 'createdAt',
          type: 'Date',
          note: '创建时间',
          showOnList: true
        })
        manager.fields.push({
          name: 'updatedAt',
          type: 'Date',
          note: '更新时间',
          showOnList: true
        })
      }
      return manager
    }
  },
  methods: {
    logout () {
      this.$store.commit('logout')
      this.$router.push('/login')
    }
  }
}



// WEBPACK FOOTER //
// ./src/admin/js/mixin.js